export default function (input) {
    const groupMap = new Map();
    const orderedGroups = [];

    input.forEach((hit, index) => {
        const isSpotCard = hit?.isSpotCard;
        const year = hit?.year;
        const month = hit?.monthName?.[0];

        const key = isSpotCard ? `spotcard-${index}` : `${year}-${month}`;

        if (!groupMap.has(key)) {
            groupMap.set(key, {
                month: isSpotCard ? null : month,
                year: isSpotCard ? null : year,
                entries: [],
                isSpotCard: isSpotCard,
            });
            orderedGroups.push(groupMap.get(key));
        }

        groupMap.get(key).entries.push(hit);
    });

    // Sort only the dated groups
    const sortedDatedGroups  = [...orderedGroups]
        .filter(group => !group.isSpotCard)
        .sort((a, b) => {
            if (a.year === b.year) {
                return new Date(`${a.month} 1, 2000`) - new Date(`${b.month} 1, 2000`);
            }
            return a.year - b.year;
        });

    // Rebuild final result preserving original order
    const finalResult = orderedGroups.map(group =>
        group.isSpotCard ? group : sortedDatedGroups .find(g => g === group)
    );

    return finalResult;
}
